import React, { useEffect, useState } from "react";
import { ScreenHeader } from "react-library";
import { useParams, useNavigate } from "react-router-dom";
import { Routes } from "../../routes";
import PlotSerivce from "../../services/plot.service";
import ActivityService from "../../services/activity.service";
import {
  TActivityType,
  TCultActivityType,
  TCurrency,
  TFarmActivityType,
} from "../../services/activity.service";

interface Plot {
  plotId: string;
  cropId: string;
  name: string;
}

import dayjs from "dayjs";
import { t } from "../../services/locale.service";

const AddActivity: React.FC = () => {
  const { plotId, orgId } = useParams();
  const headerTitle = t("addActivity");
  const farmUserId = localStorage.getItem("farmUserId");

  const [plotList, setPlotList] = useState<Plot[]>([]);
  const [selectedPlot, setSelectedPlot] = useState<Plot>();
  const [selectedCult, setSelectedCult] = useState<TCultActivityType>();
  const [selectedActivity, setSelectedActivity] = useState<TActivityType>();
  const [activityList, setActivityList] = useState<TActivityType[]>([]);
  const [cultList, setCultList] = useState<TCultActivityType[]>();
  const [hours, setHours] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);
  const [notes, setNotes] = useState<string>("");
  const [doneDate, setDoneDate] = useState<Date>(new Date());
  const [showCalendarPicker, setShowCalendarPicker] = useState<boolean>(false);
  const [Culturalrefreshing, setCulturalRefreshing] = useState<boolean>(false);
  const [cultivationCost, setCultivationCost] = useState<TCurrency>({
    currency: "INR",
    cost: -1,
  });
  const [currencyModal, setCurrencyModal] = useState<boolean>(false);
  const [uploadingImage, setUploadingImage] = useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleBackIconPress = () => {
      handleBack(); 
    };
    window.addEventListener("back-icon-press", handleBackIconPress);
    return () => {
      window.removeEventListener("back-icon-press", handleBackIconPress);
    };
  }, [navigate]);

  const handleBack = () => {
    try {
      navigate(-1);  
    } catch (error) {
      console.log(error);
    }
  };

  const currencies = ["INR", "USD", "EUR", "GBP", "JPY", "AUD"];

  const pickerHours = Array.from({ length: 100 }, (_, i) => ({
    label: i.toString(),
    value: i,
  }));

  const pickerMinutes = Array.from({ length: 60 }, (_, j) => ({
    label: j.toString(),
    value: j,
  }));
  const getPlaceHolder = (activity: string) => {
    if (activity == "scouting") return t("ObservedDiseaseActivity");
    else if (activity == "spray") return t("SprayActivity");
    else if (activity == "other") return t("OtherActivity");
    else if (activity == "nutrient") return t("NutrientActivity");
    return t("AppliedUreaActivity");
  };
  useEffect(() => {
    setNotes("");
    loadPlots();
    loadActivityTypes();

    setUploadingImage(false);

    setCultivationCost({ currency: "INR", cost: -1 });
    console.log(
      "SAd",
      showCalendarPicker,
      Culturalrefreshing,
      cultList,
      currencyModal
    );
    setDoneDate(dayjs().toDate());
  }, []);

  const handleCurrencyChange = (currency: string) => {
    setCultivationCost((prev) => ({ ...prev, currency }));
    setCurrencyModal(false);
  };

  const makeList = (data: TCultActivityType[]): TCultActivityType[] => {
    const culturalActivityList: TCultActivityType[] = [];

    for (const item of data) {
      const newItem: TCultActivityType = {
        ...item,
        name: item.displayName
      };

      culturalActivityList.push(newItem);
    }

    return culturalActivityList;
  };

  const loadCultActivityTypes = async (cropId: string) => {
    setCulturalRefreshing(true);
    if (!cropId) {
      setCulturalRefreshing(false);
      return;
    }

    const data: TCultActivityType[] = await ActivityService.getCulturalPractice(
      cropId
    );
    const processedData = makeList(data);
    setCultList(processedData);
  };

  const loadPlots = async () => {
    try {
      const res = await PlotSerivce.getPlotList(farmUserId ?? "");

      if (res.length > 0) {
        const allPlots: Plot[] = [];
        for (let i = 0; i < res.length; i++) {
          const tempPlot: Plot = {
            plotId: res[i]?.plotId || "",
            cropId: res[i]?.cropsSown?.cropId || "",
            name: res[i]?.name || "",
          };
          allPlots.push(tempPlot);
        }

        const defaultplot = allPlots.find((i) => i.plotId === plotId);
        setSelectedPlot(defaultplot);
        setPlotList(allPlots);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const loadActivityTypes = async () => {
    const res = await ActivityService.loadActivitiesType();
    setActivityList(res);
  };

  const formatDate = (date: Date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const save = async () => {
    const finalData: TFarmActivityType = {
      done: false,
      plotId: "",
      farmActivityTypeId: "",
      doneDate: new Date(),
      cropId: "",
    };

    // cult activities
    const cultActivity = selectedCult;
    // irrigation
    let totalMinutes: string | number = "";

    finalData["notes"] = notes;

    if (selectedActivity?.id === "irrigation") {
      totalMinutes = Number(hours) * 60 + Number(minutes);
      finalData["notes"] = totalMinutes.toString();
    }
    if (selectedActivity?.id === "culturalPractice") {
      if (cultActivity?.hasOwnProperty("activity")) {
        finalData.notes = cultActivity.activity;
        finalData.culturalPracticeId = cultActivity.id;
      }
    }
    finalData.done = true;
    if (cultivationCost.cost > -1) {
      finalData.activityCost = cultivationCost;
    }
    finalData.plotId = selectedPlot!.plotId!;
    finalData.farmActivityTypeId = selectedActivity!.id!;
    finalData.doneDate = doneDate;
    finalData.cropId = selectedPlot!.cropId!;

    let alerts = "";
    if (!finalData?.plotId?.length) {
      alerts += "SelectFarm";
    }
    if (!finalData?.farmActivityTypeId?.length) {
      alerts += "Select Activity";
    }
    if (alerts != "") {
      console.log("alerts", alerts);
      return;
    }

    const res = await ActivityService.saveActivity(finalData);
    navigate(Routes.calendar.replace(":plotId", plotId!).replace(":orgId", orgId!));
    console.log("saveActivity", res);

  };


  return (
    <div className="cfr-container">
      <ScreenHeader screenName={headerTitle} />
      {plotId && farmUserId && (
        <div style={{ padding: "0px 10px" }}>
          <div>
            {/* Date selection */}
            <div
              style={{
                display: "flex",
                padding: "0px 20px",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: 22,
                backgroundColor: "#e2f2e2",
                marginBottom: 20,
              }}
            >
              <p style={{ fontWeight: "bold", fontSize: 12 }}>{t("Date")}</p>
              <div
                onClick={() => {
                  setShowCalendarPicker(true);
                }}
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: 22,
                  padding: "0px 24px",
                }}
              >
                <input
                  type="date"
                  value={formatDate(doneDate)}
                  onChange={(e) => setDoneDate(new Date(e.target.value))}
                  style={{
                    border: "0px",
                    paddingRight: 10,
                    fontSize: 12,
                    color: "#434343",
                    fontWeight: "800",
                  }}
                />
              </div>
            </div>
            {/* Plot selection */}
            <div
              style={{
                alignItems: "center",
                borderRadius: 22,
                backgroundColor: "#e2f2e2",
                paddingBottom: "20px",
              }}
            >
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: 12,
                  alignSelf: "center",
                  padding: "0px 20px",
                  paddingTop: "12px",
                }}
              >
                {t("whichPlot")}
              </p>

              <div
                style={{
                  overflowX: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  padding: "0px 15px",
                }}
              >
                <div
                  style={{ display: "flex", flexWrap: "nowrap", gap: "7px" }}
                >
                  {plotList
                    ?.slice(0, Math.ceil(plotList.length / 2))
                    .map((item: Plot, index: number) => (
                      <div
                        onClick={() => {
                          setSelectedPlot(item);
                        }}
                        key={index}
                        style={{
                          margin: 2,
                          borderRadius: 10,
                          minWidth: 120,
                          alignItems: "center",
                          backgroundColor:
                            item?.plotId === selectedPlot?.plotId
                              ? "#0c9611"
                              : "#ffffff",
                        }}
                      >
                        <p
                          style={{
                            color:
                              item?.plotId === selectedPlot?.plotId
                                ? "#ffffff"
                                : "rgba(95, 88, 88, 0.62)",
                            fontWeight:
                              item?.plotId === selectedPlot?.plotId
                                ? "bold"
                                : "normal",
                            fontSize: 11,
                            textAlign: "center",
                          }}
                        >
                          {item.name}
                        </p>
                      </div>
                    ))}
                </div>

                <div
                  style={{ display: "flex", flexWrap: "nowrap", gap: "7px" }}
                >
                  {plotList
                    ?.slice(Math.ceil(plotList.length / 2))
                    .map((item: Plot, index: number) => (
                      <div
                        onClick={() => {
                          setSelectedPlot(item);
                        }}
                        key={index}
                        style={{
                          margin: 2,
                          borderRadius: 10,
                          minWidth: 120,
                          alignItems: "center",
                          backgroundColor:
                            item?.plotId === selectedPlot?.plotId
                              ? "#0c9611"
                              : "#ffffff",
                        }}
                      >
                        <p
                          style={{
                            color:
                              item?.plotId === selectedPlot?.plotId
                                ? "#ffffff"
                                : "rgba(95, 88, 88, 0.62)",
                            fontWeight:
                              item?.plotId === selectedPlot?.plotId
                                ? "bold"
                                : "normal",
                            fontSize: 11,
                            textAlign: "center",
                          }}
                        >
                          {item.name}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            {/* Activity selection */}
            <div
              style={{
                alignItems: "center",
                borderRadius: 22,
                backgroundColor: "#e2f2e2",
                paddingBottom: "20px",
                marginBottom: 20,
              }}
            >
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: 12,
                  alignSelf: "center",
                  padding: "0px 20px",
                  paddingTop: "12px",
                }}
              >
                {t("whatActivity")}
              </p>
              <div
                style={{
                  overflowX: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  padding: "0px 15px",
                }}
              >
                <div
                  style={{ display: "flex", flexWrap: "nowrap", gap: "7px" }}
                >
                  {activityList
                    ?.slice(0, Math.ceil(activityList.length / 2))
                    .map((item, index) => (
                      <div
                        onClick={() => {
                          setSelectedActivity(item);
                          if (
                            item.id === "culturalPractice" &&
                            selectedPlot?.cropId
                          ) {
                            loadCultActivityTypes(selectedPlot?.cropId);
                          }
                        }}
                        key={index}
                        style={{
                          flex: 1,
                          padding: "0px 8px",
                          margin: 2,
                          borderRadius: 10,
                          alignItems: "center",
                          backgroundColor:
                            item?.id === selectedActivity?.id
                              ? "#0c9611"
                              : "#ffffff",
                        }}
                      >
                        <p
                          style={{
                            color:
                              item?.id === selectedActivity?.id
                                ? "#ffffff"
                                : "rgba(95, 88, 88, 0.62)",
                            fontWeight:
                              item?.id === selectedActivity?.id
                                ? "bold"
                                : "normal",
                            fontSize: 11,
                            textAlign: "center",
                          }}
                        >
                          {item.displayName ||t(item.name)}
                        </p>
                      </div>
                    ))}
                </div>

                <div
                  style={{ display: "flex", flexWrap: "nowrap", gap: "7px" }}
                >
                  {activityList
                    ?.slice(Math.ceil(activityList.length / 2))
                    .map((item, index) => (
                      <div
                        onClick={() => {
                          setSelectedActivity(item);
                          if (
                            item.id === "culturalPractice" &&
                            selectedPlot?.cropId
                          ) {
                            loadCultActivityTypes(selectedPlot?.cropId);
                          }
                        }}
                        key={index}
                        style={{
                          flex: 1,
                          margin: 2,
                          borderRadius: 10,
                          alignItems: "center",
                          backgroundColor:
                            item?.id === selectedActivity?.id
                              ? "#0c9611"
                              : "#ffffff",
                        }}
                      >
                        <p
                          style={{
                            color:
                              item?.id === selectedActivity?.id
                                ? "#ffffff"
                                : "rgba(95, 88, 88, 0.62)",
                            fontWeight:
                              item?.id === selectedActivity?.id
                                ? "bold"
                                : "normal",
                            fontSize: 11,
                            textAlign: "center",
                          }}
                        >
                          {item.displayName || t(item.name)}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            {/* irrigation selection */}
            {selectedActivity &&
              selectedActivity.id &&
              selectedActivity.id === "irrigation" && (
              <div
                style={{
                  alignItems: "center",
                  borderRadius: 22,
                  backgroundColor: "#e2f2e2",
                  paddingBottom: "20px",
                }}
              >
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: 12,
                    alignSelf: "center",
                    padding: "0px 20px",
                    paddingTop: "12px",
                  }}
                >
                  {t("HowMuchToIrrigate")}
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ display: "flex", margin: "0 10px" }}>
                    <div>
                      <div
                        style={{
                          backgroundColor: "#f0f0f0",
                          borderRadius: "10px",
                          padding: "5px",
                          margin: "5px",
                        }}
                      >
                        <select
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "10px",
                            padding: "5px",
                            minWidth: "100px",
                          }}
                          value={hours ?? ""}
                          onChange={(e) => setHours(Number(e.target.value))}
                        >
                          <option value="" disabled>
                            {t("Select_hours")}
                          </option>
                          {pickerHours.map((hour) => (
                            <option key={hour.value} value={hour.value}>
                              {hour.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          color: "gray",
                          textAlign: "center",
                          fontSize: 10,
                        }}
                      >
                        {t("hours")}
                      </div>
                    </div>

                    <div>
                      <div
                        style={{
                          backgroundColor: "#f0f0f0",
                          borderRadius: "10px",
                          padding: "5px",
                          margin: "5px",
                        }}
                      >
                        <select
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "10px",
                            padding: "5px",
                            minWidth: "100px",
                          }}
                          value={minutes ?? ""}
                          onChange={(e) => setMinutes(Number(e.target.value))}
                        >
                          <option value="" disabled>
                            {t("Select_minutes")}
                          </option>
                          {pickerMinutes.map((minute) => (
                            <option key={minute.value} value={minute.value}>
                              {minute.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          color: "gray",
                          textAlign: "center",
                          fontSize: 10,
                        }}
                      >
                        {t("minutes")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* 3,4,8,9 selection */}

            {selectedActivity &&
              selectedActivity.id &&
              (selectedActivity.id === "nutrient" ||
                selectedActivity.id === "spray" ||
                selectedActivity.id === "other" ||
                selectedActivity.id === "scouting") && (
              <div
                style={{
                  borderRadius: 22,
                  backgroundColor: "#e2f2e2",
                  paddingBottom: "20px",
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: 12,
                    padding: "0px 20px",
                    paddingTop: "12px",
                  }}
                >
                  {t("Notes")}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <textarea
                    style={{
                      width: "80%",
                      border: "0px",
                      height: "100px",
                      padding: "10px",
                    }}
                    placeholder={getPlaceHolder(selectedActivity.id)}
                    value={notes}
                    onChange={(event) => {
                      setNotes(event.target.value);
                    }}
                  />
                </div>
              </div>
            )}

            {/* cultural selection */}
            {selectedActivity && selectedActivity.id === "culturalPractice" && (
              <div
                style={{
                  alignItems: "center",
                  borderRadius: 22,
                  backgroundColor: "#e2f2e2",
                  paddingBottom: "20px",
                  marginBottom: 20,
                }}
              >
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: 12,
                    alignSelf: "center",
                    padding: "0px 20px",
                    paddingTop: "12px",
                  }}
                >
                  {t("whatWithinCultActivity")}
                </p>

                <div
                  style={{
                    overflowX: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    padding: "0px 15px",
                  }}
                >
                  <div
                    style={{ display: "flex", flexWrap: "nowrap", gap: "7px" }}
                  >
                    {cultList
                      ?.slice(0, Math.ceil(cultList.length / 2))
                      .map((item: TCultActivityType, index: number) => (
                        <div
                          onClick={() => {
                            setSelectedCult(item);
                          }}
                          key={"cult" + index}
                          style={{
                            margin: 4,
                            borderRadius: 10,
                            minWidth: 120,
                            alignItems: "center",
                            backgroundColor:
                              item?.activity === selectedCult?.activity
                                ? "#0c9611"
                                : "#ffffff",
                            fontWeight:
                              item?.activity === selectedCult?.activity
                                ? "bold"
                                : "normal",
                          }}
                        >
                          <p
                            style={{
                              color:
                                item?.activity === selectedCult?.activity
                                  ? "#ffffff"
                                  : "rgba(95, 88, 88, 0.62)",
                              fontSize: 11,
                              textAlign: "center",
                            }}
                          >
                            { t( "{item.name}")}
                          </p>
                        </div>
                      ))}
                  </div>

                  <div
                    style={{ display: "flex", flexWrap: "nowrap", gap: "7px" }}
                  >
                    {cultList
                      ?.slice(Math.ceil(cultList.length / 2))
                      .map((item: TCultActivityType, index: number) => (
                        <div
                          onClick={() => {
                            setSelectedCult(item);
                          }}
                          key={
                            "cult" + (index + Math.ceil(cultList.length / 2))
                          }
                          style={{
                            margin: 4,
                            borderRadius: 10,
                            minWidth: 120,
                            alignItems: "center",
                            backgroundColor:
                              item?.activity === selectedCult?.activity
                                ? "#0c9611"
                                : "#ffffff",
                            fontWeight:
                              item?.activity === selectedCult?.activity
                                ? "bold"
                                : "normal",
                          }}
                        >
                          <p
                            style={{
                              color:
                                item?.activity === selectedCult?.activity
                                  ? "#ffffff"
                                  : "rgba(95, 88, 88, 0.62)",
                              fontSize: 11,
                              textAlign: "center",
                            }}
                          >
                            {item.name}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            style={{
              alignItems: "center",
              borderRadius: 22,
              backgroundColor: "#e2f2e2",
              paddingBottom: "20px",
              marginBottom: 20,
            }}
          >
            <p
              style={{
                fontWeight: "bold",
                fontSize: 12,
                alignSelf: "center",
                padding: "0px 20px",
                paddingTop: "12px",
              }}
            >
              {t("addCost")}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0px 15px",
              }}
            >
              <div
                style={{
                  width: "35%",
                  borderRadius: 8,
                  height: "70%",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  cursor: "pointer",
                }}
              >
                <div style={{ alignSelf: "center" }}>
                  <select
                    style={{
                      border: "0px",
                      borderRadius: "10px",
                      padding: "5px",
                      minWidth: "100px",
                    }}
                    value={cultivationCost.currency}
                    onChange={(e) => handleCurrencyChange(e.target.value)}
                  >
                    {currencies.map((currency) => (
                      <option key={currency} value={currency}>
                        {currency}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: 6,
                  alignItems: "center",
                  justifyContent: "center",
                  width: "50%",
                  height: "70%",
                }}
              >
                <input
                  style={{
                    width: "98%",
                    height: "100%",
                    padding: 4,
                    border: "0px",
                    borderRadius: 22,
                  }}
                  type="number"
                  value={
                    cultivationCost.cost === -1
                      ? ""
                      : cultivationCost.cost.toString()
                  }
                  placeholder={t("costExample")}
                  onChange={(e) => {
                    const costValue = e.target.value
                      ? Number(e.target.value)
                      : -1;
                    setCultivationCost((prev) => ({
                      ...prev,
                      cost: costValue,
                    }));
                  }}
                />
              </div>
            </div>
          </div>

          {/* Save */}
          <div
            style={{
              borderRadius: 12,
              padding: "4px 0",
              backgroundColor:
                !!selectedActivity?.id &&
                !!selectedPlot?.plotId &&
                !uploadingImage
                  ? "#0c9611"
                  : "#e2f2e2",
              alignSelf: "center",
              marginBottom: 15,
              cursor: "pointer",
            }}
            onClick={save}
          >
            <p
              style={{
                color: "#ffffff",
                alignSelf: "center",
                fontWeight: "bold",
                fontSize: 18,
                textAlign: "center",
                margin: 0,
              }}
            >
              {t("Save")}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddActivity;
